import React, { useEffect, useState } from "react";
import { Button, Input, Space } from "antd";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
import { filter, isEmpty } from "lodash";
import moment from "moment";

import OrdersRoutePlanTable from "../Table/OrdersRoutePlan";
import { getStopDeliveryOrder } from "../../utils/helper";
import { DATE_FORMAT_FRONTEND, DATETIME_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

const PAGE_SIZE = 100;

const RoutePlanOrders = ({
  id,
  routePlan,
  orders,
  routes,
  doRemoveOrdersRoutePlan,
  doDetailRoutePlan,
  onClickStop,
  canEdit,
  setting,
}) => {
  const [searchValue, setSearchValue] = useState(null);
  const [searchedOrders, setSearchedOrders] = useState([]);
  const [queryOrders, setQueryOrders] = useState({});
  const [loading, setLoading] = useState(false);
  const [modifying, setModifying] = useState(false);

  const currentPage = Number(queryOrders.currentPage) || 1;
  const itemsPerPage = Number(queryOrders.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    showTotal: total => `${total} ${getTranslation(setting, "Orders", "Orders")}`,
  };

  useEffect(() => {
    setSearchedOrders(orders);
  }, [orders]);

  useEffect(() => {
    let ordersT = orders;
    if (!isEmpty(searchValue)) {
      ordersT = filter(orders, o => {
        return (
          o.orderCode?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.orderRef?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.pickupName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.pickupAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.pickupPhone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.deliveryName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.deliveryAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.deliveryPhone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          moment(o.deliveryDate).format(DATE_FORMAT_FRONTEND).toLowerCase().match(searchValue.toLowerCase()) ||
          o.timeStart?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.timeEnd?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          moment(o.createdAt).format(DATE_FORMAT_FRONTEND).toLowerCase().match(searchValue.toLowerCase()) ||
          moment(o.updatedAt).format(DATETIME_FORMAT_FRONTEND).toLowerCase().match(searchValue.toLowerCase()) ||
          o.status?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
    }
    setSearchedOrders(ordersT);
  }, [searchValue]);

  const handleOnSearch = e => {
    setLoading(true);
    setTimeout(() => {
      setSearchValue(e.target.value);
      setLoading(false);
    }, 100);
  };

  const handleBulkUpdate = selectedOrders => {
    return {
      title:
        selectedOrders.length > 0
          ? `${selectedOrders.length} ${getTranslation(setting, "Route Plans", "orders selected")}`
          : "",
      actions: (
        <Space>
          {selectedOrders.length > 0 && (
            <Button
              className="btn-add-to-route"
              size="large"
              key="RemoveFromRoute"
              onClick={() => handleRemoveOrders(selectedOrders)}
              type="primary">
              {getTranslation(setting, "Common", "Remove")}
            </Button>
          )}
        </Space>
      ),
    };
  };

  const handleRemoveOrders = async selectedOrders => {
    setModifying(true);
    await doRemoveOrdersRoutePlan({
      id: id,
      orders: selectedOrders.map(s => s._id),
    });
    await doDetailRoutePlan(id);
    setModifying(false);
  };

  const onClickRowOrder = record => {
    return {
      onClick: () => {
        const stop = getStopDeliveryOrder(record);
        onClickStop(stop);
      },
    };
  };

  const handleTableChange = params => {
    setLoading(true);
    setTimeout(() => {
      setQueryOrders(params);
      setLoading(false);
    }, 100);
  };

  return (
    <div className={`RoutePlanOrders ${canEdit ? "canEdit" : "cannotEdit"}`}>
      <div className="MainLeft__Header">
        <div className="MainLeft__Header__Title">
          {canEdit ? (
            <Link to="/route-plans">{getTranslation(setting, "Route Plans", "Route Plans")}</Link>
          ) : (
            getTranslation(setting, "Route Plans", "Route Plans")
          )}
          <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
          <span className="Link">
            {routePlan?.name} (
            <span className="Capitalize">
              {moment(routePlan?.deliveryDate).utc().locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND)}
            </span>
            )
          </span>
        </div>
        <div className="MainLeft__Header__Search">
          <Input.Search size="large" placeholder="Search Anything" onChange={handleOnSearch} />
          {canEdit && (
            <Link to={`/route-plans/${id}/add-orders`}>
              <Button size="large" className="NewButton" type="primary">
                {getTranslation(setting, "Route Plans", "Add Orders")}
                <ReactSVG className="icon" src="/icons/add.svg" />
              </Button>
            </Link>
          )}
        </div>
      </div>
      <OrdersRoutePlanTable
        rowKey="_id"
        pagination={pagination}
        dataSource={searchedOrders}
        scrollHeight={canEdit ? "calc(100vh - 398px)" : "calc(100vh - 315px)"}
        bulkUpdate={canEdit ? handleBulkUpdate : null}
        onRow={onClickRowOrder}
        onChange2={handleTableChange}
        query={queryOrders}
        loading={loading}
        modifying={modifying}
        routes={routes}
        canEdit={canEdit}
        setting={setting}
        routePlanType={routePlan.type || "PDP"}
      />
    </div>
  );
};

export default RoutePlanOrders;
